import styled from 'styled-components';
import { colors } from 'Constants/Colors';

export const PanelBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  overflow: scroll;
  overflow-x: hidden;
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const Courses = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

export const CoursesTitle = styled.h3`
  font-family: var(--app-font);
  font-weight: 100;
`;

export const PanelBodyItem = styled.div`
  width: 100%;
`;

export const ButtonStyle = {
  backgroundColor: 'transparent',
  color: colors.GRAY_DARK,
};

export default { PanelBody, PanelBodyItem };
